import React, { useEffect, useState, useMemo, useCallback } from "react";
import { logEventos } from "../../../services/services";
import {
  Container,
  Typography,
  ListItemIcon,
  Button,
  MenuItem,
  Box,
  lighten,
  Tooltip,
  IconButton,
  Grid,
  TextField,
  Chip,
  Stack,
  Skeleton,
  Paper,
  Tabs,
  Tab,
} from "@mui/material";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { getData, putData } from "../../../services/library";
import Navbar from "../../Navbar";
import ChecklistIcon from "@mui/icons-material/Checklist";
import DetalleRendicion from "./detailPanel/DetalleRendicion";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useFechas } from "../pedidosEnvasado/context/FechaContext";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import FinalizarRendicionDialog from "./finalizar/FinalizarRendicionDialog";
import DownloadIcon from "@mui/icons-material/Download";
import DescargarCsv from "./Csv/DescargarCsv";
import MapIcon from "@mui/icons-material/Map";
import AsignarHojaRuta from "./hojaRuta/AsignarHojaRuta";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import NuevaRendicion from "./nuevaRendicion/NuevaRendicion";
import CompletarDatosNew from "./completarDatos/CompletarDatosNew";
import SummarizeIcon from "@mui/icons-material/Summarize";
import ResumenPagos from "./resumenPagos/ResumenPagos";
import ResumenRendicion from "./resumenRendicion/ResumenRendicion";
import PedidosHojaTabla from "./VistaPedidos/PedidosHojaTabla";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import MarcarRendicionInactiva from "./inactiva/MarcarRendicionInactiva";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import PasaPedidos from "./pasarPedidos/PasaPedidos";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import TablaRendicionesExtendidas from "./rendicionesExtendidas/TablaRendicionesExtendidas";

function Rendiciones_envasados() {
  const [tabla, setTabla] = useState(true);
  const [rendiciones, setRendiciones] = useState([]);
  const [verPedidos, setVerPedidos] = useState(false);
  const [completarDatos, setCompletarDatos] = useState(false);
  const [finalizarRendicion, setFinalizarRendicion] = useState(false);
  const [descargarCsv, setDescargarCsv] = useState(false);
  const [row, setRow] = useState();
  const { desde, hasta, setDesde, setHasta } = useFechas();
  const [hojaRuta, setHojaRuta] = useState(false);
  const [nuevaRendicion, setNuevaRendicion] = useState(false);
  const [verResumen, setVerResumen] = useState(false);
  const [verResumenRendicion, setVerResumenRendicion] = useState(false);
  const [marcarInactivo, setMarcarInactivo] = useState(false);
  const [pasaPedidos, setPasaPedidos] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [rendicionesExtendidasData, setRendicionesExtendidasData] = useState(
    [],
  );
  const [loadingExtendidas, setLoadingExtendidas] = useState(false);

  const obtenerRendiciones = () => {
    setLoading(true);
    getData(
      "/envasado_rendiciones/sucauth/" +
        desde +
        "/" +
        hasta +
        "/" +
        localStorage.getItem("suc_auth").split(","),
      (data) => {
        setRendiciones(data);
        setLoading(false);
      },
      (error) => {
        console.error("Error al cargar rendiciones:", error);
        setLoading(false);
      },
    );
  };

  const obtenerRendicionesExtendidas = () => {
    setLoadingExtendidas(true);
    getData(
      "/envasado_rendiciones/sucauthextendidas/" +
        desde +
        "/" +
        hasta +
        "/" +
        localStorage.getItem("suc_auth").split(","),
      (data) => {
        setRendicionesExtendidasData(data);
        setLoadingExtendidas(false);
      },
      (error) => {
        console.error("Error al cargar rendiciones extendidas:", error);
        setLoadingExtendidas(false);
      },
    );
  };

  useEffect(() => {
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  }, []);

  const handleUpdate = () => {
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "fecha", //access nested data with dot notation
        header: "Fecha",
        size: 95,
      },
      {
        accessorKey: "patente", //access nested data with dot notation
        header: "Vehiculo",
        size: 110,
        Cell: ({ cell, row }) => (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* ícono solo si id_hoja no es null/undefined */}
            {row.original.hoja_ruta != null ? (
              <Tooltip title="Tiene hoja de ruta">
                <MapIcon color="black" fontSize="small" />
              </Tooltip>
            ) : null}
            {/* mostrar el valor original de la celda */}
            <span>{cell.getValue() ?? ""}</span>
          </Box>
        ),
      },
      {
        accessorKey: "nombre_apellido", //access nested data with dot notation
        header: "Chofer",
        size: 150,
      },
      // {
      //   accessorKey: "reparto_tarde", //access nested data with dot notation
      //   header: "Tarde",
      //   size: 70,
      // },
      {
        accessorKey: "nombre_suc", //access nested data with dot notation
        header: "Sucursal",
        size: 70,
      },
      {
        accessorKey: "valor", //access nested data with dot notation
        header: "Estado",
        size: 97,
        Cell: ({ cell, row }) => (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* ícono solo si id_hoja no es null/undefined */}
            {row.original.activo === 0 && row.original.estado !== 274 ? (
              <Tooltip title="La rendición esta inactiva">
                <DoDisturbIcon color="error" fontSize="small" />
              </Tooltip>
            ) : null}
            {/* mostrar el valor original de la celda */}
            <span>{cell.getValue() ?? ""}</span>
          </Box>
        ),
      },
      {
        accessorKey: "pedidos_pendientes",
        header: "Pendientes",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();

          if (!value || value === 0) {
            return (
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  fontStyle: "italic",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <PendingActionsIcon sx={{ fontSize: 16, opacity: 0.6 }} />
                Sin pendientes
              </Typography>
            );
          }

          return (
            <Tooltip title={`${value} pedidos pendientes`}>
              <Chip
                icon={<PendingActionsIcon />}
                label={`${value} pendiente${value > 1 ? "s" : ""}`}
                size="small"
                color="warning"
                variant="filled"
                sx={{
                  fontWeight: 500,
                }}
              />
            </Tooltip>
          );
        },
      },
    ],
    [],
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  const initialState = {
    density: "compact",
    pagination: { pageIndex: 0, pageSize: 50 },
    grouping: ["fecha", "nombre_suc"],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const handleVerPedidos = (row) => {
    setTabla(false);
    setRow(row);
    setVerPedidos(true);
  };

  const handleCompletarDatos = (row) => {
    // setTabla(false);
    setRow(row);
    setCompletarDatos(true);
  };

  const handleVerResumen = (row) => {
    // setTabla(false);
    setRow(row);
    setVerResumen(true);
  };

  const handleVerResumenRendicion = (row) => {
    setTabla(false);
    setRow(row);
    setVerResumenRendicion(true);
  };

  const handleFinalizarRendicion = (row) => {
    // setTabla(false);
    setRow(row);
    setFinalizarRendicion(true);
  };

  const handleDescargarCsv = (row) => {
    // setTabla(false);
    setRow(row);
    setDescargarCsv(true);
  };

  const handleMarcarInactivo = (row) => {
    // setTabla(false);
    setRow(row);
    setMarcarInactivo(true);
  };

  const handlePasarPedidos = (row) => {
    // setTabla(false);
    setRow(row);
    setPasaPedidos(true);
  };

  const handleHojaRuta = (row) => {
    // setTabla(false);
    setRow(row);
    setHojaRuta(true);
  };

  const handleNuevaRendicion = (row) => {
    // setTabla(false);
    // setRow(row);
    setNuevaRendicion(true);
  };

  const handleVolver = () => {
    setVerPedidos(false);
    setTabla(true);
  };

  const handleVolverDatos = () => {
    setCompletarDatos(false);
    setTabla(true);
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  };

  const handleVolverResumen = () => {
    setVerResumen(false);
    setTabla(true);
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  };

  const handleVolverResumenRendicion = () => {
    setVerResumenRendicion(false);
    setTabla(true);
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  };

  const handleVolverFinalizar = () => {
    setFinalizarRendicion(false);
    setTabla(true);
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  };

  const handleVolverHojaRuta = () => {
    setHojaRuta(false);
    setTabla(true);
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  };

  const handleVolverNuevaRendicion = () => {
    setNuevaRendicion(false);
    setTabla(true);
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  };

  const handleVolverDescargar = () => {
    setDescargarCsv(false);
    setTabla(true);
    // obtenerRendiciones()
  };

  const handleVolverInactivo = () => {
    setMarcarInactivo(false);
    setTabla(true);
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  };

  const handleVolverPasaPedidos = () => {
    setPasaPedidos(false);
    setTabla(true);
    obtenerRendiciones();
    obtenerRendicionesExtendidas();
  };

  useEffect(() => {
    logEventos(
      "acceso al menú Rendiciones",
      "Envasado",
      "Rendiciones",
      localStorage.getItem("user"),
    );
  }, []);

  return (
    <div>
      {tabla && (
        <>
          <Navbar />
          {loading ? (
            <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 2 }}>
              <Box sx={{ p: 3 }}>
                <Stack spacing={2}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={56}
                    animation="wave"
                  />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={500}
                    animation="wave"
                  />
                </Stack>
              </Box>
            </Container>
          ) : (
            // <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 2 }}>
            //   <MaterialReactTable
            //     columns={columns}
            //     data={rendiciones ?? [{}]}
            //     layoutMode={"grid"}
            //     initialState={initialState}
            //     enableColumnActions={false} //deshabilita las acciones POR COLUMN}
            //     enableGlobalFilterModes={false}
            //     enableHiding={false}
            //     enableRowActions={true}
            //     enableGrouping={true}
            //     enablePinning={true}
            //     enableColumnFilters={false}
            //     enableFullScreenToggle={false}
            //     positionActionsColumn={"last"}
            //     positionToolbarAlertBanner="none"
            //     stateIsLoading={loading}
            //     enableExpandAll={false}
            //     localization={customLocalization}
            //     enableToolbarInternalActions={true}
            //     muiTableHeadCellProps={tableHeadCellProps}
            //     muiSearchTextFieldProps={muiSearchTextFieldProps}
            //     enableDensityToggle={false}
            //     muiTableBodyRowProps={({ row }) => ({
            //       sx: {
            //         backgroundColor:
            //           row.original.estado === 272
            //             ? null
            //             : row.original.estado === 273
            //               ? "#ffff88"
            //               : row.original.estado === 274
            //                 ? "#acec98"
            //                 : null,
            //       },
            //     })}
            //     muiTableDetailPanelProps={{
            //       sx: {
            //         backgroundColor: "white", // Fondo blanco para el panel de detalles
            //         width: "100%",
            //       },
            //     }}
            //     enableColumnResizing={true}
            //     renderDetailPanel={({ row }) => (
            //       <DetalleRendicion row={row.original} />
            //     )}
            //     muiTableBodyCellProps={({ row }) => ({
            //       align: "left",
            //     })}
            //     renderTopToolbarCustomActions={() => (
            //       <>
            //         <Typography variant="poster" fontSize={26}>
            //           Rendiciones
            //         </Typography>
            //         <Grid
            //           container
            //           spacing={2}
            //           justifyContent="center"
            //           alignItems="center"
            //         >
            //           <Grid item>
            //             <Button
            //               startIcon={<AddCircleOutlineIcon />}
            //               size="small"
            //               variant="contained"
            //               color="primary"
            //               onClick={handleNuevaRendicion}
            //             >
            //               Nueva Rendición
            //             </Button>
            //           </Grid>
            //           <Grid item>
            //             <TextField
            //               size="small"
            //               label="Desde"
            //               type="date"
            //               value={desde}
            //               onChange={(e) => setDesde(e.target.value)}
            //               InputLabelProps={{ shrink: true }}
            //               variant="outlined"
            //             />
            //           </Grid>
            //           <Grid item>
            //             <TextField
            //               size="small"
            //               label="Hasta"
            //               type="date"
            //               value={hasta}
            //               onChange={(e) => setHasta(e.target.value)}
            //               InputLabelProps={{ shrink: true }}
            //               variant="outlined"
            //             />
            //           </Grid>
            //           <Grid item>
            //             <Tooltip title="Actualizar">
            //               <IconButton
            //                 onClick={handleUpdate}
            //                 sx={{
            //                   backgroundColor: "#e0e0e0",
            //                   "&:hover": { backgroundColor: "#d5d5d5" },
            //                 }}
            //               >
            //                 <RefreshIcon sx={{ color: "#333" }} />
            //               </IconButton>
            //             </Tooltip>
            //           </Grid>
            //         </Grid>
            //       </>
            //     )}
            //     renderRowActionMenuItems={({ closeMenu, row, index }) => [
            //       <MenuItem
            //         key={index}
            //         onClick={() => {
            //           handleVerPedidos(row.original);
            //           closeMenu();
            //         }}
            //         sx={{ m: 0 }}
            //       >
            //         <ListItemIcon>
            //           <RemoveRedEyeIcon color="primary" />
            //         </ListItemIcon>
            //         Ver Pedidos
            //       </MenuItem>,
            //       <MenuItem
            //         key={index}
            //         // style={{
            //         //   display: row.original.activo === 0 ? null : "none",
            //         // }}
            //         // disabled={row.original.activo === 1}
            //         onClick={() => {
            //           handleCompletarDatos(row.original);
            //           closeMenu();
            //         }}
            //         sx={{ m: 0 }}
            //       >
            //         <ListItemIcon>
            //           <CreateNewFolderIcon color="secondary" />
            //         </ListItemIcon>
            //         Completar Datos
            //       </MenuItem>,
            //       <MenuItem
            //         key={index}
            //         onClick={() => {
            //           handleVerResumen(row.original);
            //           closeMenu();
            //         }}
            //         sx={{ m: 0 }}
            //       >
            //         <ListItemIcon>
            //           <SummarizeIcon color="warning" />
            //         </ListItemIcon>
            //         Resumen de Pagos
            //       </MenuItem>,
            //       <MenuItem
            //         key={index}
            //         onClick={() => {
            //           handleVerResumenRendicion(row.original);
            //           closeMenu();
            //         }}
            //         sx={{ m: 0 }}
            //       >
            //         <ListItemIcon>
            //           <ChecklistIcon color="success" />
            //         </ListItemIcon>
            //         Resumen de Rendición
            //       </MenuItem>,
            //       // <MenuItem
            //       //   key={index}
            //       //   style={{
            //       //     display: row.original.estado === 274 ? null : "none",
            //       //   }}
            //       //   disabled={row.original.estado !== 274}
            //       //   onClick={() => {
            //       //     handleDescargarCsv(row.original)
            //       //     closeMenu();
            //       //   }}
            //       //   sx={{ m: 0 }}
            //       // >
            //       //   <ListItemIcon>
            //       //     <DownloadIcon color="default" />
            //       //   </ListItemIcon>
            //       //   Descargar CSV
            //       // </MenuItem>,
            //       <MenuItem
            //         key={index}
            //         // style={{
            //         //   display: row.original.estado === 273 ? null : "none",
            //         // }}
            //         disabled={
            //           row.original.estado === 273 || row.original.activo === 0
            //         }
            //         onClick={() => {
            //           handleMarcarInactivo(row.original);
            //           closeMenu();
            //         }}
            //         sx={{ m: 0 }}
            //       >
            //         <ListItemIcon>
            //           <DoDisturbIcon color="error" />
            //         </ListItemIcon>
            //         Marcar Inactiva
            //       </MenuItem>,
            //       <MenuItem
            //         key={index}
            //         style={{
            //           display: row.original.activo === 0 ? null : "none",
            //         }}
            //         disabled={row.original.estado === 274}
            //         onClick={() => {
            //           handlePasarPedidos(row.original);
            //           closeMenu();
            //         }}
            //         sx={{ m: 0 }}
            //       >
            //         <ListItemIcon>
            //           <ChangeCircleIcon color="primary" />
            //         </ListItemIcon>
            //         Pasar Pedidos
            //       </MenuItem>,
            //     ]}
            //   />
            // </Container>
            <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 2 }}>
              <Paper sx={{ width: "100%", mb: 2 }}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    bgcolor: "#f5f5f5",
                  }}
                >
                  <Tab label={`Diarias (${rendiciones?.length || 0})`} />
                  <Tab
                    label={`Extendidas (${rendicionesExtendidasData?.length || 0})`}
                  />
                </Tabs>

                <Box sx={{ p: 0 }}>
                  {tabValue === 0 && (
                    <MaterialReactTable
                      columns={columns}
                      data={rendiciones ?? []}
                      layoutMode={"grid"}
                      initialState={initialState}
                      enableColumnActions={false}
                      enableGlobalFilterModes={false}
                      enableHiding={false}
                      enableRowActions={true}
                      enableGrouping={true}
                      enablePinning={true}
                      enableColumnFilters={false}
                      enableFullScreenToggle={false}
                      positionActionsColumn={"last"}
                      positionToolbarAlertBanner="none"
                      stateIsLoading={loading}
                      enableExpandAll={false}
                      localization={customLocalization}
                      enableToolbarInternalActions={true}
                      muiTableHeadCellProps={tableHeadCellProps}
                      muiSearchTextFieldProps={muiSearchTextFieldProps}
                      enableDensityToggle={false}
                      muiTableBodyRowProps={({ row }) => ({
                        sx: {
                          backgroundColor:
                            row.original.estado === 272
                              ? null
                              : row.original.estado === 273
                                ? "#ffff88"
                                : row.original.estado === 274
                                  ? "#acec98"
                                  : null,
                        },
                      })}
                      muiTableDetailPanelProps={{
                        sx: {
                          backgroundColor: "white",
                          width: "100%",
                        },
                      }}
                      enableColumnResizing={true}
                      renderDetailPanel={({ row }) => (
                        <DetalleRendicion row={row.original} />
                      )}
                      muiTableBodyCellProps={({ row }) => ({
                        align: "left",
                      })}
                      renderTopToolbarCustomActions={() => (
                        <>
                          <Typography variant="poster" fontSize={26}>
                            Rendiciones
                          </Typography>
                          <Grid
                            container
                            spacing={2}
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Grid item>
                              <Button
                                startIcon={<AddCircleOutlineIcon />}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={handleNuevaRendicion}
                              >
                                Nueva Rendición
                              </Button>
                            </Grid>
                            <Grid item>
                              <TextField
                                size="small"
                                label="Desde"
                                type="date"
                                value={desde}
                                onChange={(e) => setDesde(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item>
                              <TextField
                                size="small"
                                label="Hasta"
                                type="date"
                                value={hasta}
                                onChange={(e) => setHasta(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item>
                              <Tooltip title="Actualizar">
                                <IconButton
                                  onClick={handleUpdate}
                                  sx={{
                                    backgroundColor: "#e0e0e0",
                                    "&:hover": { backgroundColor: "#d5d5d5" },
                                  }}
                                >
                                  <RefreshIcon sx={{ color: "#333" }} />
                                </IconButton>
                              </Tooltip>
                            </Grid>
                          </Grid>
                        </>
                      )}
                      renderRowActionMenuItems={({ closeMenu, row, index }) => [
                        <MenuItem
                          key={index}
                          onClick={() => {
                            handleVerPedidos(row.original);
                            closeMenu();
                          }}
                          sx={{ m: 0 }}
                        >
                          <ListItemIcon>
                            <RemoveRedEyeIcon color="primary" />
                          </ListItemIcon>
                          Ver Pedidos
                        </MenuItem>,
                        <MenuItem
                          key={index}
                          onClick={() => {
                            handleCompletarDatos(row.original);
                            closeMenu();
                          }}
                          sx={{ m: 0 }}
                        >
                          <ListItemIcon>
                            <CreateNewFolderIcon color="secondary" />
                          </ListItemIcon>
                          Completar Datos
                        </MenuItem>,
                        <MenuItem
                          key={index}
                          onClick={() => {
                            handleVerResumen(row.original);
                            closeMenu();
                          }}
                          sx={{ m: 0 }}
                        >
                          <ListItemIcon>
                            <SummarizeIcon color="warning" />
                          </ListItemIcon>
                          Resumen de Pagos
                        </MenuItem>,
                        <MenuItem
                          key={index}
                          onClick={() => {
                            handleVerResumenRendicion(row.original);
                            closeMenu();
                          }}
                          sx={{ m: 0 }}
                        >
                          <ListItemIcon>
                            <ChecklistIcon color="success" />
                          </ListItemIcon>
                          Resumen de Rendición
                        </MenuItem>,
                        <MenuItem
                          key={index}
                          disabled={
                            row.original.estado === 273 ||
                            row.original.activo === 0
                          }
                          onClick={() => {
                            handleMarcarInactivo(row.original);
                            closeMenu();
                          }}
                          sx={{ m: 0 }}
                        >
                          <ListItemIcon>
                            <DoDisturbIcon color="error" />
                          </ListItemIcon>
                          Marcar Inactiva
                        </MenuItem>,
                        <MenuItem
                          key={index}
                          style={{
                            display: row.original.activo === 0 ? null : "none",
                          }}
                          disabled={row.original.estado === 274}
                          onClick={() => {
                            handlePasarPedidos(row.original);
                            closeMenu();
                          }}
                          sx={{ m: 0 }}
                        >
                          <ListItemIcon>
                            <ChangeCircleIcon color="primary" />
                          </ListItemIcon>
                          Pasar Pedidos
                        </MenuItem>,
                      ]}
                    />
                  )}

                  {tabValue === 1 && (
                    <TablaRendicionesExtendidas
                      data={rendicionesExtendidasData}
                      loading={loadingExtendidas}
                      desde={desde}
                      hasta={hasta}
                      setDesde={setDesde}
                      setHasta={setHasta}
                      onUpdate={handleUpdate}
                      onNuevaRendicion={handleNuevaRendicion}
                      onVerPedidos={handleVerPedidos}
                      onCompletarDatos={handleCompletarDatos}
                      onVerResumen={handleVerResumen}
                      onVerResumenRendicion={handleVerResumenRendicion}
                      onMarcarInactivo={handleMarcarInactivo}
                      onPasarPedidos={handlePasarPedidos}
                      columns={columns}
                      tableHeadCellProps={tableHeadCellProps}
                      muiSearchTextFieldProps={muiSearchTextFieldProps}
                      customLocalization={customLocalization}
                    />
                  )}
                </Box>
              </Paper>
            </Container>
          )}
        </>
      )}
      {verPedidos && <PedidosHojaTabla row={row} onBack={handleVolver} />}
      {/* {verPedidos && <PedidosRendicionTable row={row} onBack={handleVolver} />} */}
      {completarDatos && (
        <CompletarDatosNew
          open={completarDatos}
          onClose={handleVolverDatos}
          username={localStorage.getItem("user")}
          rendicion={row}
        />
      )}
      {finalizarRendicion && (
        <FinalizarRendicionDialog
          open={finalizarRendicion}
          onClose={handleVolverFinalizar}
          username={localStorage.getItem("user")}
          rendicion={row}
        />
      )}
      {descargarCsv && (
        <DescargarCsv
          open={descargarCsv}
          onClose={handleVolverDescargar}
          username={localStorage.getItem("user")}
          rendicion={row}
        />
      )}
      {hojaRuta && (
        <AsignarHojaRuta
          open={hojaRuta}
          onClose={handleVolverHojaRuta}
          username={localStorage.getItem("user")}
        />
      )}

      {nuevaRendicion && (
        <NuevaRendicion
          open={nuevaRendicion}
          onClose={handleVolverNuevaRendicion}
          username={localStorage.getItem("user")}
        />
      )}
      {verResumen && (
        <ResumenPagos
          open={verResumen}
          onClose={handleVolverResumen}
          username={localStorage.getItem("user")}
          datos={row}
        />
      )}

      {verResumenRendicion && (
        <ResumenRendicion row={row} onBack={handleVolverResumenRendicion} />
      )}
      {marcarInactivo && (
        <MarcarRendicionInactiva
          open={marcarInactivo}
          onClose={handleVolverInactivo}
          username={localStorage.getItem("user")}
          rendicion={row}
        />
      )}
      {pasaPedidos && (
        <PasaPedidos
          open={pasaPedidos}
          onClose={handleVolverPasaPedidos}
          username={localStorage.getItem("user")}
          rendicion={row}
        />
      )}
    </div>
  );
}

export default Rendiciones_envasados;
